import React from 'react';

import { Flex, Stack } from '@atlaskit/primitives/compiled';

import { getFeatureInfo } from '../../../common/getFeatureInfo';
import type { AudioFeature } from '../../../types/audioFeature';
import { useAudioPlayerStore } from '../../hooks/useAudioPlayerStore';
import { ModifyPlaylistButton } from '../playlist/ModifyPlaylistButtons';

import { AudioFeatureToggle } from './AudioFeatureToggle';
import { AudioHeader } from './AudioHeader';

export type AudioHeaderPanelProps = {
	featureList: AudioFeature[];
};

export const AudioHeaderPanel = ({ featureList }: AudioHeaderPanelProps) => {
	const { activeFeature, setActiveFeature } = useAudioPlayerStore();

	const activeFeatureInfo = getFeatureInfo(activeFeature, featureList);

	const getNextFeature = () => {
		const currentIndex = featureList.findIndex(
			(feature) => feature.name === activeFeatureInfo?.name,
		);
		const nextIndex = (currentIndex + 1) % featureList.length;
		return featureList[nextIndex];
	};

	return (
		<Stack space="space.250" alignInline="center">
			<AudioHeader featureList={featureList} />
			<Flex gap="space.050" alignItems="center">
				<ModifyPlaylistButton
					isInPlaylist={true}
					addToPlaylist={() => {}}
					removeFromPlaylist={() => {}}
					round={true}
				/>
				<AudioFeatureToggle
					featureList={featureList}
					onClick={() => setActiveFeature(getNextFeature().name)}
				/>
			</Flex>
		</Stack>
	);
};
